module.exports = __webpack_public_path__ + "static/media/Soleil-Bold.5824cc23.otf";